var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3804_40078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53516 23.2011V0.798871C3.53516 0.357647 3.89285 0 4.33403 0H17.7547C19.2524 0 20.4666 1.21416 20.4666 2.71191V23.2011C20.4666 23.6424 20.1089 24 19.6677 24H4.33403C3.89285 24 3.53516 23.6424 3.53516 23.2011Z",
    fill: "url(#paint0_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7547 0H13.9416V6.088C13.9416 6.52922 14.2993 6.88687 14.7404 6.88687H16.6179C17.6927 6.88687 18.5639 7.75812 18.5639 8.83289V20.3921H3.53516V21.8592H17.7563C18.2024 21.8592 18.564 22.2208 18.564 22.6668V23.2011C18.564 23.6424 18.2063 24 17.7651 24H19.6678C20.109 24 20.4666 23.6424 20.4666 23.2011V2.71191C20.4666 1.21416 19.2525 0 17.7547 0Z",
    fill: "url(#paint1_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7564 0H15.1133V4.91788C15.1133 5.35911 15.4709 5.71675 15.9122 5.71675H20.4682V2.71191C20.4683 1.21416 19.2541 0 17.7564 0Z",
    fill: "url(#paint2_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2595 20.6891H2.74196C2.2157 20.6891 1.78906 20.2625 1.78906 19.7362V14.8823C1.78906 14.3561 2.2157 13.9294 2.74196 13.9294H21.2596C21.7858 13.9294 22.2125 14.3561 22.2125 14.8823V19.7362C22.2125 20.2625 21.7858 20.6891 21.2595 20.6891Z",
    fill: "url(#paint3_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2582 13.9294H19.3555C19.8817 13.9294 20.3084 14.3561 20.3084 14.8823V19.7362C20.3084 20.2625 19.8818 20.6891 19.3555 20.6891H21.2582C21.7844 20.6891 22.211 20.2625 22.211 19.7362V14.8823C22.2111 14.3561 21.7845 13.9294 21.2582 13.9294Z",
    fill: "url(#paint4_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51016 17.4968H6.35487V19.0702C6.35487 19.2559 6.12842 19.3488 5.90202 19.3488C5.67562 19.3488 5.44922 19.2559 5.44922 19.0702V15.3778C5.44922 15.1863 5.67567 15.105 5.90202 15.105C6.12847 15.105 6.35487 15.1863 6.35487 15.3778V16.8002H7.51016V15.3778C7.51016 15.1863 7.73661 15.105 7.96301 15.105C8.18941 15.105 8.41581 15.1863 8.41581 15.3778V19.0702C8.41581 19.2559 8.18941 19.3488 7.96301 19.3488C7.73661 19.3488 7.51016 19.2559 7.51016 19.0702V17.4968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5581 15.105C11.7497 15.105 11.831 15.314 11.831 15.5056C11.831 15.7262 11.7323 15.9178 11.5581 15.9178H10.757V19.0702C10.757 19.2559 10.5306 19.3488 10.3042 19.3488C10.0778 19.3488 9.85132 19.2559 9.85132 19.0702V15.9178H9.05019C8.87603 15.9178 8.77734 15.7262 8.77734 15.5056C8.77734 15.314 8.85861 15.105 9.05019 15.105H11.5581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2349 17.8452C14.1595 17.9729 14.0434 18.0136 13.9331 18.0136C13.8285 18.0136 13.7183 17.9788 13.6486 17.8452L13.0971 16.8351V19.0702C13.0971 19.2559 12.8706 19.3488 12.6442 19.3488C12.4178 19.3488 12.1914 19.2559 12.1914 19.0702V15.5578C12.1914 15.2269 12.4179 15.105 12.6442 15.105C12.9693 15.105 13.1087 15.1398 13.3467 15.5578L13.9447 16.6029L14.5427 15.5578C14.7807 15.1399 14.92 15.105 15.2451 15.105C15.4773 15.105 15.6979 15.2269 15.6979 15.5578V19.0702C15.6979 19.2559 15.4715 19.3488 15.2451 19.3488C15.0187 19.3488 14.7923 19.2559 14.7923 19.0702V16.8931L14.2349 17.8452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.719 19.3488C16.5216 19.3488 16.3242 19.2559 16.3242 19.0702V15.3778C16.3242 15.1863 16.5507 15.105 16.777 15.105C17.0035 15.105 17.2299 15.1863 17.2299 15.3778V18.5592H18.5535C18.7277 18.5592 18.8148 18.7566 18.8148 18.954C18.8148 19.1514 18.7277 19.3488 18.5535 19.3488H16.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3321 6.96681C9.56184 6.73711 9.56184 6.36464 9.3321 6.1349C9.10241 5.90525 8.72998 5.90521 8.50019 6.1349L6.20071 8.43438C5.66226 8.97283 5.66226 9.84902 6.20071 10.3875L8.50019 12.6869C8.61502 12.8018 8.7656 12.8592 8.91615 12.8592C9.06669 12.8592 9.21723 12.8018 9.3321 12.6869C9.56184 12.4573 9.56184 12.0848 9.3321 11.855L7.03262 9.55556C6.95285 9.47579 6.95285 9.34601 7.03262 9.26629L9.3321 6.96681Z",
    fill: "url(#paint5_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8037 8.43443L15.5042 6.13495C15.2745 5.90521 14.902 5.90521 14.6723 6.13495C14.4426 6.36469 14.4426 6.73712 14.6723 6.96686L16.9718 9.26634C17.0516 9.3461 17.0516 9.47589 16.9718 9.55561L14.6723 11.8551C14.4426 12.0848 14.4426 12.4573 14.6723 12.687C14.7871 12.8019 14.9377 12.8593 15.0883 12.8593C15.2388 12.8593 15.3893 12.8019 15.5042 12.687L17.8037 10.3875C18.3421 9.84902 18.3421 8.97288 17.8037 8.43443Z",
    fill: "url(#paint6_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.528 5.62487C13.2268 5.50341 12.8839 5.64905 12.7624 5.95037L10.1483 12.4318C10.0268 12.7331 10.1726 13.0759 10.4738 13.1974C10.5459 13.2265 10.6204 13.2403 10.6937 13.2403C10.9265 13.2403 11.147 13.1011 11.2394 12.8719L13.8535 6.39042C13.975 6.08915 13.8293 5.74642 13.528 5.62487Z",
    fill: "url(#paint7_linear_3804_40078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.256 6.88681L15.5042 6.13495C15.2745 5.90521 14.9019 5.90521 14.6722 6.13495C14.4717 6.33552 14.4463 6.64479 14.5959 6.87298C14.6431 6.88163 14.6915 6.88681 14.7412 6.88681H16.256Z",
    fill: "url(#paint8_linear_3804_40078)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3804_40078",
    x1: 1.95986,
    y1: 12,
    x2: 22.8559,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#F8F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3804_40078",
    x1: -22.8697,
    y1: 12,
    x2: 36.2818,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CEEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3804_40078",
    x1: 15.5138,
    y1: 2.8584,
    x2: 21.6745,
    y2: 2.8584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#F8F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3804_40078",
    x1: 1.78902,
    y1: 17.3093,
    x2: 25.4149,
    y2: 17.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FE556D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#FE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2024E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3804_40078",
    x1: 8.84643,
    y1: 17.3093,
    x2: 19.1527,
    y2: 17.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FE556D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#FE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2024E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3804_40078",
    x1: 5.88504,
    y1: 9.41095,
    x2: 19.6688,
    y2: 9.41095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FE556D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#FE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2024E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3804_40078",
    x1: 5.88407,
    y1: 9.411,
    x2: 19.6678,
    y2: 9.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FE556D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#FE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2024E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3804_40078",
    x1: 5.88328,
    y1: 9.41117,
    x2: 19.667,
    y2: 9.41117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FE556D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#FE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2024E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3804_40078",
    x1: 9.27224,
    y1: 6.42474,
    x2: 15.3669,
    y2: 6.42474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FE556D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#FE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2024E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3804_40078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.fa3d27b0b41a8947e6f52a4fdcde5e10.svg";
export { ForwardRef as ReactComponent };